import { isEmpty } from '@/helper/funcoes.js';

export function montarCoordenadasAtendimento(atendimento) {
    let coordenadas = [];

    if (Object.keys(atendimento).length > 0) {
        if (
            Object.prototype.hasOwnProperty.call(atendimento, "enderecoOrigem") &&
            Object.prototype.hasOwnProperty.call(atendimento.enderecoOrigem, "latitude") && 
            !isEmpty(atendimento.enderecoOrigem.latitude) &&
            Object.prototype.hasOwnProperty.call(atendimento.enderecoOrigem, "longitude") && 
            !isEmpty(atendimento.enderecoOrigem.longitude)
        ) {
            coordenadas.push({
                icone: '/img/marcador-carro.png',
                lat: atendimento.enderecoOrigem.latitude,
                long: atendimento.enderecoOrigem.longitude,
                texto: 'Origem'
            });
        }

        if (
            Object.prototype.hasOwnProperty.call(atendimento, "enderecoDestino") && 
            Object.prototype.hasOwnProperty.call(atendimento.enderecoDestino, "latitude") && 
            !isEmpty(atendimento.enderecoDestino.latitude) &&
            Object.prototype.hasOwnProperty.call(atendimento.enderecoDestino, "longitude") && 
            !isEmpty(atendimento.enderecoDestino.longitude)
        ) {
            coordenadas.push({
                icone: '/img/marcador-bandeira.png',
                lat: atendimento.enderecoDestino.latitude,
                long: atendimento.enderecoDestino.longitude,
                texto: 'Destino'
            });
        }
    }

    return coordenadas;
}

export function montarCoordernasPrestador(servico) {
    const coordenadas = [];

    if (Object.keys(servico).length > 0) {
        if (
            Object.prototype.hasOwnProperty.call(servico, 'posicoesPrestador') && 
            servico.posicoesPrestador.length > 0 &&
            Object.prototype.hasOwnProperty.call(servico.posicoesPrestador[0], "latitude") && 
            !isEmpty(servico.posicoesPrestador[0].latitude) &&
            Object.prototype.hasOwnProperty.call(servico.posicoesPrestador[0], "longitude") && 
            !isEmpty(servico.posicoesPrestador[0].longitude)
        ) {
            const ultimaPosicaoArray = servico.posicoesPrestador.length - 1;

            coordenadas.push({
                icone: '/img/marcador-ultima-posicao.png',
                lat: servico.posicoesPrestador[ultimaPosicaoArray].latitude,
                long: servico.posicoesPrestador[ultimaPosicaoArray].longitude,
                texto: servico.descricao
            });     
        }          
    }

    return coordenadas;
}